import React, {memo} from "react";

function Number2(props) {
    const { record } = props;

    return (
        <div className="BaseTable__row-cell-text">
            {record.number2 || '-'}
        </div>
    );
}

export default memo(Number2);
